let baseUrl;
baseUrl = "http://localhost:5000/v1";
baseUrl = "https://api-drunkenbytes.onrender.com/v1"
export default baseUrl;